module.exports = __webpack_public_path__ + "static/esailingTV-6923799e755628459d985c262f73898a.png";